/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpAiService, createClient } from '@squiz/dxp-ai-client';
import { BaseService } from 'apps/console-core/src/Services/_base';
import { AiServiceConfiguration } from './Ai.service.config';

export class AiService extends BaseService {
  public readonly apiClient: DxpAiService<unknown>;
  /**
   * Creates an instance of AiService.
   */
  public constructor(configuration: AiServiceConfiguration) {
    super(configuration);
    const baseUrl = this.getServiceUrlByTenant('ai');
    if (!baseUrl) {
      throw new Error('BaseUrl is undefined');
    }
    const httpClient = createClient({
      baseUrl: baseUrl,
    });
    this.apiClient = new DxpAiService(httpClient);
  }
}
